import { Routes } from '@angular/router';

import { BossComponent } from './containers/boss/boss.component';

export const BOSS_ROUTES: Routes = [
  {
    path: '',
    children: [{ path: '', component: BossComponent }],
  },
];
